"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskCollisionStrategy = void 0;
var TaskCollisionStrategy;
(function (TaskCollisionStrategy) {
    TaskCollisionStrategy[TaskCollisionStrategy["DEFAULT"] = 0] = "DEFAULT";
    TaskCollisionStrategy[TaskCollisionStrategy["KEEP_THIS"] = 1] = "KEEP_THIS";
    TaskCollisionStrategy[TaskCollisionStrategy["KEEP_OTHER"] = 2] = "KEEP_OTHER";
    TaskCollisionStrategy[TaskCollisionStrategy["KEEP_BOTH"] = 3] = "KEEP_BOTH";
    TaskCollisionStrategy[TaskCollisionStrategy["RESOLVE_THIS"] = 4] = "RESOLVE_THIS";
    TaskCollisionStrategy[TaskCollisionStrategy["RESOLVE_OTHER"] = 5] = "RESOLVE_OTHER";
})(TaskCollisionStrategy = exports.TaskCollisionStrategy || (exports.TaskCollisionStrategy = {}));
